<div
  class="w-12 m-4 text-qr_color-gray hover:cursor-pointer flex mt-10"
  @click="handleSwapColor"
>
  <SwapIcon class="fill-current" />
</div>
